export default __webpack_public_path__ + "static/media/onTheSpotPrecheck.44862896.svg";